import { configureStore } from '@reduxjs/toolkit'
import makerCheckerGamesReducer from '../slices/maker-checker';
import publishedGamesReducer from '../slices/published-games';
import draftedGamesReducer from '../slices/drafts';
import gamePropertiesReducer from '../slices/properties';
import userInfoReducer from '../slices/user-info';

export const store = configureStore({
  reducer: {
    publishedGames: publishedGamesReducer,
    makerCheckerGames: makerCheckerGamesReducer,
    draftedGames: draftedGamesReducer,
    gameProperties: gamePropertiesReducer,
    userInfo: userInfoReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type dispatcher = typeof store.dispatch;
